import { render, staticRenderFns } from "./chooseTic.vue?vue&type=template&id=07f3f5f7&"
import script from "./chooseTic.vue?vue&type=script&lang=js&"
export * from "./chooseTic.vue?vue&type=script&lang=js&"
import style0 from "./chooseTic.vue?vue&type=style&index=0&id=07f3f5f7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports